export default "__VITE_ASSET__BGZL8ENr__"